import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { Check, Columns3 } from "lucide-react";
import type { ListColumn } from "../core";

interface ColumnChooserProps {
    columns: ListColumn[];
    hidden: Set<string>;
    onToggle: (name: string) => void;
}

// Show/hide list columns. Stays open across toggles (preventDefault on select).
export function ColumnChooser({ columns, hidden, onToggle }: ColumnChooserProps) {
    return (
        <DropdownMenu.Root>
            <DropdownMenu.Trigger asChild>
                <button type="button" className="search-panel__toggle" aria-label="Choose columns" title="Columns">
                    <Columns3 size={15} />
                </button>
            </DropdownMenu.Trigger>
            <DropdownMenu.Portal>
                <DropdownMenu.Content className="rdx-menu" align="end" sideOffset={4}>
                    <div className="rdx-menu__label">Columns</div>
                    {columns.map((c) => {
                        const visible = !hidden.has(c.name);
                        return (
                            <DropdownMenu.Item
                                key={c.name}
                                className="rdx-menu__item"
                                onSelect={(e) => {
                                    e.preventDefault();
                                    onToggle(c.name);
                                }}
                            >
                                <span className="rdx-menu__tick">{visible ? <Check size={14} /> : null}</span>
                                <span className="rdx-menu__item-primary">{c.label}</span>
                            </DropdownMenu.Item>
                        );
                    })}
                </DropdownMenu.Content>
            </DropdownMenu.Portal>
        </DropdownMenu.Root>
    );
}
